import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { Send } from "lucide-react";

const AnimatedBlock = ({ children, delay = 0 }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-60px" });
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 30 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.8, delay, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
};

const CtaSection = () => {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      data-testid="cta-section"
      className="py-24 md:py-32 relative overflow-hidden"
      style={{
        background: "linear-gradient(135deg, #442F23 0%, #5a3d2e 50%, #442F23 100%)",
      }}
    >
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#E1C340]/8 rounded-full blur-[120px]" />

      <div className="max-w-3xl mx-auto px-6 lg:px-12 relative text-center">
        <AnimatedBlock>
          <h2 className="font-heading text-4xl md:text-5xl font-semibold tracking-tight text-[#FBF8E9] mb-6">
            Quanto vale la tua Luce Interiore?
          </h2>
        </AnimatedBlock>

        <AnimatedBlock delay={0.1}>
          <p className="font-body text-base md:text-lg text-[#FBF8E9]/70 leading-relaxed mb-4">
            Se vuoi ottenere risultati diversi, devi cominciare a fare cose nuove,
            anche quando ti spaventano.
          </p>
        </AnimatedBlock>

        <AnimatedBlock delay={0.2}>
          <p className="font-body text-base text-[#E1C340] leading-relaxed mb-12">
            Prendi coraggio ora e comincia il tuo percorso,
            perch&eacute; nessuno &egrave; responsabile della tua felicit&agrave; se non te stessa/o.
          </p>
        </AnimatedBlock>

        <AnimatedBlock delay={0.3}>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <button
              onClick={() => scrollTo("pricing-section")}
              className="btn-primary text-base flex items-center justify-center gap-2"
              data-testid="cta-pricing-btn"
            >
              Voglio Iscrivermi
            </button>
          </div>
        </AnimatedBlock>

        <AnimatedBlock delay={0.4}>
          <div className="bg-[#FBF8E9]/10 backdrop-blur-md rounded-[2rem] p-8 md:p-12 border border-[#FBF8E9]/10">
            <p className="font-heading text-2xl text-[#FBF8E9] mb-2">
              Iscriviti al canale Telegram gratuito
            </p>
            <p className="font-accent text-xl text-[#E1C340] mb-4">
              "Viaggio di Luce"
            </p>
            <p className="font-body text-sm text-[#FBF8E9]/60 mb-8 max-w-md mx-auto">
              Troverai molti audio training su tematiche di crescita personale
              e spiritualit&agrave;, ispirazioni quotidiane e pratiche gratuite.
            </p>

            <a
              href="https://t.me/+Yw8T5GX-wq5iMjFk"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary inline-flex items-center gap-2 text-base"
              data-testid="telegram-channel-btn"
            >
              <Send size={18} />
              Unisciti a Viaggio di Luce
            </a>
          </div>
        </AnimatedBlock>
      </div>
    </section>
  );
};

export default CtaSection;
